export default __webpack_public_path__ + "static/media/resume.b6947294.pdf";